'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = VegetarianSvg;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function VegetarianSvg(props) {
    var size = props.size,
        primaryColor = props.primaryColor,
        _props$i18n = props.i18n,
        i18n = _props$i18n === undefined ? { get: function get() {
            return null;
        } } : _props$i18n;


    return _react2.default.createElement(
        'svg',
        { role: 'img', 'aria-labelledby': 'outImgVeg', width: size, height: size, viewBox: '0 0 28 28', xmlns: 'http://www.w3.org/2000/svg', 'data-hook': 'wixrest-menus-icon-outline-vegetarian' },
        _react2.default.createElement(
            'title',
            { id: 'outImgVeg' },
            i18n.get('openrest_menubuilderv3_dishlabels_vegetarian') || 'vegetarian'
        ),
        _react2.default.createElement(
            'g',
            { fill: primaryColor },
            _react2.default.createElement('path', {
                d: 'M21.7344 13.4638c-.138-.139-.308-.21-.506-.21h-2.36c-.198 0-.371.069-.512.204-.14.135-.212.31-.212.521 0 .201.072.372.212.507s.313.205.512.205h1.542v1.999c-.224.102-.493.187-.801.253-1.008.214-1.904.094-2.663-.359-.518-.308-.932-.733-1.232-1.258-.299-.526-.452-1.114-.452-1.75 0-.635.152-1.226.452-1.756.3-.53.715-.953 1.233-1.257.515-.304 1.094-.458 1.721-.458.586 0 1.165.131 1.706.379.25.154.637.186.906-.104.133-.142.203-.32.203-.517 0-.124-.03-.233-.091-.336-.061-.102-.151-.188-.268-.255-.34-.203-.726-.355-1.145-.453-.419-.1-.86-.149-1.311-.149-.905 0-1.745.22-2.501.654-.754.434-1.358 1.033-1.793 1.779-.434.745-.654 1.577-.654 2.473 0 .896.22 1.729.654 2.475.435.746 1.039 1.346 1.793 1.779.755.434 1.596.655 2.501.655.526 0 1.044-.077 1.538-.226.497-.148.96-.36 1.372-.63.239-.15.361-.364.361-.633v-3.017c0-.198-.068-.37-.202-.512l-.003-.003zM12.3701 8.9116c-.117.082-.208.192-.282.345l-2.684 6.72-2.846-6.727c-.172-.391-.457-.473-.664-.473-.181 0-.343.063-.498.195-.15.13-.226.304-.226.516 0 .089.011.216.054.302l3.432 8.124c.066.129.159.236.271.309.117.076.237.117.39.128.127-.001.264-.044.383-.12.132-.078.234-.195.307-.352l3.414-8.075c.05-.115.076-.226.076-.33 0-.191-.074-.355-.222-.489-.259-.233-.633-.261-.905-.073' }),
            _react2.default.createElement('path', {
                d: 'M13.6499 25.999c-6.81 0-12.35-5.54-12.35-12.349 0-6.81 5.54-12.35 12.35-12.35s12.35 5.54 12.35 12.35c0 6.809-5.54 12.349-12.35 12.349m0-25.999c-7.527 0-13.65 6.123-13.65 13.65 0 7.526 6.123 13.65 13.65 13.65s13.651-6.124 13.651-13.65c0-7.527-6.124-13.65-13.651-13.65' })
        )
    );
}

VegetarianSvg.displayName = 'VegetarianSvg';
VegetarianSvg.propTypes = {
    size: _propTypes2.default.number,
    primaryColor: _propTypes2.default.string
};
VegetarianSvg.defaultProps = {
    size: 28,
    primaryColor: '#a9c360'
};